// Hook - Inbox watkow PENDING_REVIEW (dealId IS NULL) skrzynki biezacego tradera.
// GET /api/ui/sales-crm/notify/inbox
// Sprint 4 v4.1.

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetNotifyInboxResponse } from 'api/types/notify';

export interface IUseGetNotifyInboxParams {
  page?: number;
  perPage?: number;
}

export const NOTIFY_INBOX_QUERY_KEY_BASE = ['sales-crm-notify', 'inbox'] as const;

export const getNotifyInboxQueryKey = (params: IUseGetNotifyInboxParams = {}) =>
  [...NOTIFY_INBOX_QUERY_KEY_BASE, params.page ?? 1, params.perPage ?? 20] as const;

const getNotifyInbox = (
  params: IUseGetNotifyInboxParams = {}
): Promise<IGetNotifyInboxResponse> =>
  axios.get('/sales-crm/notify/inbox', {
    params: { page: params.page ?? 1, perPage: params.perPage ?? 20 }
  });

export const useGetNotifyInbox = (
  params: IUseGetNotifyInboxParams = {},
  options?: UseQueryOptions<IGetNotifyInboxResponse, IError>
) =>
  useQuery<IGetNotifyInboxResponse, IError>(
    getNotifyInboxQueryKey(params),
    () => getNotifyInbox(params),
    {
      staleTime: 15_000,
      ...options
    }
  );
